export default "__VITE_PUBLIC_ASSET__8e80ea50__"